const currency = window?.Shopify?.currency?.active || 'EUR';
let locale = 'de-DE';
if(currency === 'CHF') {
    locale = 'de-CH'
}
if(currency === 'GBP') {
    locale = 'en-GB'
}
if(window?.Shopify?.locale === 'fr') {
    locale = 'fr-FR'
}
if(window?.Shopify?.locale === 'es') {
    locale = 'es-ES'
}
if(window?.Shopify?.locale === 'it') {
    locale = 'it-IT'
}


// narrowSymbol needs Safari 14.1 / iOS 14.5+. Older engines throw a RangeError
// while the formatter is built, and since that happens at import time it took
// down every module that imports this file (the cart's free-shipping label, the
// regions script). Fall back to the plain symbol, which renders the same for
// EUR, CHF and GBP.
const makeFormatter = (options = {}) => {
  const base = { style: 'currency', currency, ...options };
  try {
    return new Intl.NumberFormat(locale, { ...base, currencyDisplay: 'narrowSymbol' });
  } catch {
    return new Intl.NumberFormat(locale, { ...base, currencyDisplay: 'symbol' });
  }
};

const formatter = makeFormatter();

const formatterWeight = makeFormatter({
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatMoney = function(cents) {
    const amount = cents / 100;
    return formatter.format(amount);
}

export const formatMoneyKg = function(cents) {
    const amount = cents / 100;
    return `${formatterWeight.format(amount)} / kg`;
}

export const formatMoneyL = function(cents) {
    const amount = cents / 100;
    return `${formatterWeight.format(amount)} / l`;
}
